<div class="pt-10 px-10 pb-10">
  <h1 class="page-title">Minha Conta</h1>
  <div>
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
      <div class="container p-6 bg-white shadow-lg rounded-lg flex flex-col">
        <div class="flex items-start gap-8">
          <div class="flex flex-col items-center flex-shrink-0 mt-1">
            <div class="w-20 h-20 mb-2">
              <img [src]="getImageUrl()" alt="Profile Photo" class="h-full w-full rounded-full object-cover"
                onerror="this.src='assets/img/profile_placeholder.png'" />
            </div>
            <input type="file" #file (change)="onFileChange($event)" class="hidden" accept="image/*" />
            <a class="text-sm font-medium text-primary hover:underline cursor-pointer" (click)="file.click()">Alterar foto</a>
          </div>
          <div class="flex-1 flex flex-col gap-4">
            <div>
              <label for="nome-completo" class="block text-sm font-medium text-gray-700 mb-1">Nome completo</label>
              <div class="input-field"
                [ngClass]="{'input-field-error': nomeCompleto?.invalid && nomeCompleto?.touched && nomeCompleto?.value, 'input-field-focus': !(nomeCompleto?.invalid && nomeCompleto?.touched && nomeCompleto?.value)}">
                <input type="text" id="nome-completo" formControlName="nomeCompleto"
                  class="input-element py-2" placeholder="Nome Completo" />
              </div>
              <div *ngIf="nomeCompleto?.invalid && nomeCompleto?.touched && nomeCompleto?.value"
                class="text-red-500 text-sm mt-1">
                <div *ngIf="nomeCompleto?.errors?.['required']">Nome completo é obrigatório.</div>
              </div>
            </div>
            <div>
              <label for="email" class="block text-sm font-medium text-gray-700 mb-1">E-mail</label>
              <div class="input-field"
                [ngClass]="{'input-field-error': userForm.get('email')?.invalid && !emailFocused && userForm.get('email')?.touched && userForm.get('email')?.value, 'input-field-focus': !(userForm.get('email')?.invalid && !emailFocused && userForm.get('email')?.touched && userForm.get('email')?.value)}">
                <input id="email" type="email" formControlName="email" placeholder="Insira o seu e-mail"
                  class="input-element py-2" (focus)="emailFocused = true" (blur)="emailFocused = false" />
              </div>
              <div
                *ngIf="userForm.get('email')?.invalid && !emailFocused && userForm.get('email')?.touched && userForm.get('email')?.value"
                class="text-red-500 text-sm mt-1">
                <div *ngIf="userForm.get('email')?.errors?.['required']">E-mail é obrigatório.</div>
                <div *ngIf="userForm.get('email')?.errors?.['email']">E-mail inválido.</div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex justify-end mt-6">
          <button type="submit" class="button-compact button-color-primary max-w-44 w-full"
            [ngClass]="{'button-disabled': userForm.invalid || !hasChanges}" [disabled]="userForm.invalid || !hasChanges">
            Salvar alterações
          </button>
        </div>
      </div>


      <div class="container p-7 bg-white shadow-lg rounded-lg mt-5">
        <h2 class="text-xl font-bold mb-4 text-primary-dark">Segurança</h2>
        <div class="flex justify-between items-center">
          <div>
            <p class="text-base font-semibold text-primary-dark">Senha</p>
            <p *ngIf="user?.passwordChangeDate" class="text-base font-normal text-primary-gray">
              Última alteração há {{ getLastPasswordChangeText() }}
            </p>
            <p *ngIf="!user?.passwordChangeDate" class="text-base font-normal text-primary-gray">
              A senha nunca foi alterada
            </p>
          </div>
          <button type="button" class="button-compact button-color-gray max-w-32 w-full" (click)="alterarSenha()">
            Alterar senha
          </button>
        </div>
      </div>


    </form>
  </div>
</div>
